import {
  IOrderedWithPaginationInputModel,
  IRiskMatrixInputModel,
} from 'inputModels';
import { api } from 'services';
import {
  IResponse,
  IRiskMatrixViewModel,
  IVoidResponse,
} from 'viewModels';

const getRiskMatrices = <T>(
  input?: IOrderedWithPaginationInputModel<T>
) =>
  new Promise<IResponse<IRiskMatrixViewModel[]>>(
    (resolve, reject) => {
      api
        .get(
          `riskmatrix/get?page=${input?.page}&take=${input?.take}${
            input?.term ? `&term=${input?.term}` : ''
          }${
            input?.filter ? `&filter=${input?.filter}` : ''
          }&${input?.orderBy
            ?.map(
              (o, i) =>
                `orderBy[${i}].key=${o.key}&orderBy[${i}].direction=${o.direction}`
            )
            .join('&')}`
        )
        .then(({ data }) => resolve(data))
        .catch(reject);
    }
  );

const createRiskMatrix = (input: IRiskMatrixInputModel) =>
  new Promise<IResponse<string>>((resolve, reject) => {
    api
      .post('riskmatrix/create', input)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });

const updateRiskMatrix = (input: IRiskMatrixInputModel) =>
  new Promise<IResponse<IRiskMatrixViewModel>>((resolve, reject) => {
    api
      .put('riskmatrix/update', input)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });

const updateRiskMatrixStatus = (input: string) =>
  new Promise<IVoidResponse>((resolve, reject) => {
    api
      .put(`riskmatrix/update-status?id=${input}`)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });

const deleteRiskMatrix = (input: string) =>
  new Promise<IVoidResponse>((resolve, reject) => {
    api
      .delete(`riskmatrix/delete?id=${input}`)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });

// const exportReport = (input: string) =>
//   new Promise<IVoidResponse>((resolve, reject) => {
//     api
//       .post(`riskmatrix/report?id=${input}`)
//       .then(({ data }) => resolve(data))
//       .catch(reject);
//   });

export const exportReport = (id: string): Promise<void> => {
  return new Promise<void>((resolve, reject) => {
    api
      .get(`riskmatrix/report?id=${id}`, {
        responseType: 'blob',
      })
      .then(({ data }) => {
        let reportName = 'Relátorio de Matrix de Risco';

        download(data, `${reportName}.pdf`);
        resolve();
      })
      .catch(reject);
  });
};

const download = (data: any, name: string) => {
  const blob = new Blob([data], {
    type: 'application/pdf',
  });
  const uri = window.URL.createObjectURL(blob);

  if (!uri) return;
  const link = document.createElement('a');

  link.href = uri;
  link.setAttribute('download', name);
  link.rel = 'noopener noreferrer';
  link.referrerPolicy = 'no-referrer';
  link.click();

  link.parentElement?.removeChild(link);
  window.URL.revokeObjectURL(uri);
};

export const RiskMatrixController = {
  getRiskMatrices,
  createRiskMatrix,
  updateRiskMatrix,
  deleteRiskMatrix,
  updateRiskMatrixStatus,
  exportReport,
};
